import React, {Fragment} from 'react';
import {Props} from '../Builder/ElementProperties';

//const PLACEHOLDER = "data:image/svg+xml,%3Csvg%20fill%3D%22%23bbbbbb%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20width%3D%2224%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22/%3E%0A%20%20%20%20%3Cpath%20d%3D%22M21%2019V5c0-1.1-.9-2-2-2H5c-1.1%200-2%20.9-2%202v14c0%201.1.9%202%202%202h14c1.1%200%202-.9%202-2zM8.5%2013.5l2.5%203.01L14.5%2012l4.5%206H5l3.5-4.5z%22/%3E%0A%3C/svg%3E";
const PLACEHOLDER = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18'%3E%3Cpath transform='translate%28-3,-3%29' fill='%23d6d6d6' d='M8.5,13.5L11,16.5L14.5,12L19,18H5M21,19V5C21,3.89 20.1,3 19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19Z' /%3E%3C/svg%3E";

const ImageElement = (props) => {
	
	let onClick = Props.onClickAreaHandler.bind(this,{props, elementType:'image'});
	let url = Props.getMediaURL({props});

	if(!url || (url.indexOf('http') !== 0 &&  url.indexOf('data') !== 0 && url.indexOf('blob:http') !==0)){
		url = PLACEHOLDER;
	}

	return (
		<div
			style={{
				width:'100%',
				height:'100%',
				backgroundImage:`url("${url}")`,
				backgroundSize:'contain',
				backgroundRepeat:'no-repeat',
				backgroundPosition:'center center',
			}}
			onClick = {onClick}>

		</div>
	);
}

const Properties = (props) => (
	<Fragment>
		<Props.Id {...props} />
		<Props.X {...props} />
		<Props.Y {...props} />
		<Props.Width {...props} />
		<Props.Height {...props} />
		<Props.URL {...props} />
		<Props.OnClick {...props} />
	</Fragment>
);

ImageElement.type = 'image';
ImageElement.Properties = Properties;
ImageElement.defaultJSON = {type: 'image', id:'New Image', x: 250, y:250, width:200, height:200, url:PLACEHOLDER, onClick:''};
export default ImageElement;


// WEBPACK FOOTER //
// ./src/components/ScreenElements/ImageElement.js